export interface ICreateAnnualReportAuditLog {
    entityId: string;

    collection: string;

    action: string;
}

export enum AnnualReportAction {
    SEAL = 'seal',
    UNSEAL = 'unseal',
}
